<template>
  <analytics-sub-page
    title="Pay Analytics"
    icon="money-bill-wave"
    css-class="analytics-pay"
    default-label="Pay"
    :section-specs="sectionSpecs"
  >
    <stream-metrics ref="streamRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import StreamMetrics from '@/pages/analyticsApp/components/StreamMetrics.vue';

const streamRef = ref(null);

const sectionSpecs = [{ key: 'pay', label: 'Pay', ref: streamRef }];
</script>
